// @docs https://[domain]/api/v1/docs
export default {
  Create: "/pyr/productivity-salaries/run",
  CheckRule: "/pyr/payrolls/check-rule",
  LockData: "/pyr/locks",
  Create13ThMonthSalary: "/pyr/run-13th",
};
